import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { SUPPORT_SERVER_URL } from "@/config";

const columns = [
  {
    title: "Product",
    links: [
      { label: "Features", to: "/features" },
      { label: "Commands", to: "/commands" },
      { label: "Premium", to: "/premium" },
      { label: "Docs", to: "/docs" },
      { label: "Dashboard", to: "/dashboard" },
    ],
  },
  {
    title: "Resources",
    links: [
      { label: "Support", to: "/support" },
      { label: "Status", to: "/status" },
      { label: "FAQ", to: "/faq" },
    ],
  },
  {
    title: "Legal",
    links: [
      { label: "Terms", to: "/terms" },
      { label: "Privacy", to: "/privacy" },
      { label: "Server Data Deletion", to: "/server-deletion" },
    ],
  },
];

export const Footer = () => (
  <footer className="border-t border-white/5 bg-ink-900" data-testid="footer">
    <div className="mx-auto grid w-full max-w-7xl gap-10 px-6 py-16 grid-cols-2 md:grid-cols-[1.4fr_1fr_1fr_1fr_1fr] md:py-20">
      <div className="col-span-2 md:col-span-1">
        <Logo />
        <p className="mt-5 max-w-xs text-sm leading-relaxed text-paper-500">
          The next generation Discord bot. Powerful moderation, advanced automation, and a better Discord experience.
        </p>
      </div>
      {columns.map((col) => (
        <nav key={col.title} aria-label={col.title}>
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-paper-500">{col.title}</p>
          <ul className="mt-5 space-y-3">
            {col.links.map((link) => (
              <li key={link.to}>
                <Link
                  to={link.to}
                  data-testid={`footer-link-${link.label.toLowerCase().replace(/\s+/g, "-")}`}
                  className="text-sm text-paper-400 transition-colors duration-300 hover:text-paper-100"
                >
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </nav>
      ))}
      <nav aria-label="Community">
        <p className="text-xs font-bold uppercase tracking-[0.2em] text-paper-500">Community</p>
        <ul className="mt-5 space-y-3">
          <li>
            <a
              href={SUPPORT_SERVER_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-link-discord"
              className="text-sm text-paper-400 transition-colors duration-300 hover:text-paper-100"
            >
              Discord
            </a>
          </li>
        </ul>
      </nav>
    </div>
    <div className="border-t border-white/5">
      <div className="mx-auto flex w-full max-w-7xl flex-col gap-2 px-6 py-6 text-xs text-paper-500 sm:flex-row sm:items-center sm:justify-between">
        <p data-testid="footer-copyright">© 2026 Xevon. All rights reserved.</p>
        <p className="font-mono">xevonbot.xyz</p>
      </div>
    </div>
  </footer>
);
